// import dynamic from "next/dynamic";
// import Head from "next/head";

// const DynamicDesktop = dynamic(() =>
//   import("../components/homePage/DesktopHomePage")
// );

// const DynamicMobile = dynamic(() =>
//   import("../components/homePage/MobileHomePage")
// );

// export default function Home({ mobileView }) {
//   return (
//     <>
//       <Head>
//         <title>POS Solutions for Small, Medium & Large Businesses</title>
//         <meta
//           name="description"
//           content="QueueBuster is India's leading POS solutions provider, managing Billing, Inventory, Online Dukaan, CRM & Loyalty and many more. With over 85,000 satisfied merchants makes it India's No.1 Super Business App. "
//         />
//         <link rel="canonical" href="https://queuebuster.co" />
//         <link rel="alternate" href="https://queuebuster.co" hrefLang="en-us" />
//         <meta
//           property="og:title"
//           content="Most Powerful Point of Sale Solution for Small, Medium & Large Businesses - Get Your Free Demo, Today!"
//         />
//         <meta
//           property="og:description"
//           content="QueueBuster is India's leading POS solution streamlining businesses from small shops to large scale enterprises. We offer a comprehensive management of Billing, Inventory, Online Dukaan, CRM & Loyalty and many more."
//         />
//         <meta
//           property="og:image"
//           content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/ALL-IN-ONE_OG.jpg"
//         />
//             <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet"/>
//             <link href="https://www.ai6i.com/web.js" rel=''/>

//       </Head>
//       {mobileView ? <DynamicMobile /> : <DynamicDesktop />}
//     </>
//   );
// }




import { useEffect } from "react";
import { useRouter } from "next/router";
import Loading from "@/components/common/Loading";

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    
    const isUAE =
      timeZone === "Asia/Dubai";
     
    if (isUAE) {
      router.replace("/ae-en");
    } else {
      router.replace("/in-en");
    }
  }, []);

  return <Loading />; 
}
